import React from 'react';
import ReactPixel from 'react-facebook-pixel';

import {
  Router,
  Route,
  Switch
} from 'react-router-dom';
import { useEffect, useContext } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import About from './components/About';
import Buy from './components/Buy';
import Evaluation from './components/Evaluation';
import Sell from './components/Sell';
import Browse from './components/Browse';
import Meta from './components/Meta';
import Listings from './components/listings/Listings';
import ListingLayout from "./components/ListingLayout";
import CommunityLayout from "./components/CommunityLayout";
import BlogLayout from "./components/BlogLayout";
import AdminLayout from "./components/AdminLayout";

import Account from './components/Account';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import GeneralBrowse from './components/GeneralBrowse';
import NoMatch from './components/NoMatch';
import SignUp from "./base/sign-up.jsx";
import Logout from "./base/Logout.jsx";
import ReactGA from 'react-ga';

import 'normalize.css';
import "./app.sass";
import { userRequest, isNotEmpty } from "./util/user";
import createHistory from 'history/createBrowserHistory'

import Helmet from "react-helmet";
import renderIf from "render-if";
import { AuthContext } from "./util/context";

const history = createHistory()
history.listen((location, action) => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
});

const advancedMatching = { }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/pixel-with-ads/conversion-tracking#advanced_match
const options = {
    autoConfig: true, 	// set pixel's autoConfig
    debug: false, 		// enable logs
};
ReactPixel.init('407110670084219', advancedMatching, options);

// Scroll restoration based on https://reacttraining.com/react-router/web/guides/scroll-restoration.
export var ScrollToTop = withRouter(
  class ScrollToTopWithoutRouter extends React.Component {
    componentDidUpdate(prevProps) {
      if (this.props.location !== prevProps.location) {
        window.scrollTo(0, 0)
      }

      ReactPixel.pageView();
    }

    render() {
      return null;
    }
  }
);

const Routes = (props) => {
  const { token, userData, setAuth } = useContext(AuthContext);
  const auth_token = localStorage.getItem("auth_token");

  useEffect(() => {
    if (isNotEmpty(auth_token) || isNotEmpty(token)) {
      userRequest().then((userData) => {
        let to_use = auth_token || token
        setAuth({userData, token: to_use})
      });
    }
  }, []);

  // note: need to test for forgot password, account calls?
  const updateUserForRoutes = userData => {
    const token = localStorage.getItem("auth_token");
    setAuth({token, userData});
  };

  return (
    <Router history={history}>
      <React.Fragment>
        <Meta />
        <ScrollToTop />
        <Navigation />

        <div className="full-ctn-body">
          <Switch>
            <Route exact path="/" render={() => <Listings user={userData} />}/>
            <Route path="/general_browse" render={() => <GeneralBrowse user={userData} />}/>
            <Route path="/browse" render={() => <Browse user={userData} />}/>
            <Route path="/about" render={() => <About user={userData} />}/>
            <Route path="/account" render={() => <Account updateUserForRoutes={updateUserForRoutes} user={userData} />}/>
            <Route path="/buy" render={() => <Buy user={userData} />}/>
            <Route path="/evaluation" render={() => <Evaluation user={userData} />}/>
            <Route path="/sell" render={() => <Sell user={userData} />}/>
            <Route path="/listings/" render={() => <ListingLayout updateUserForRoutes={updateUserForRoutes} user={userData}/>}/>
            <Route path="/admin/posts/" render={() => <AdminLayout user={userData} admin={true} />}/>
            <Route path="/posts/" render={() => <BlogLayout user={userData}/>}/>
            <Route path="/communities/" render={() => <CommunityLayout user={userData}/>}/>
            <Route path="/logout" render={() => <Logout/>}/>
            <Route component={NoMatch} />
          </Switch>

          <Footer user={userData}/>
        </div>
      </React.Fragment>
    </Router>
  )
};

export default Routes;
